import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { itemDescription, itemLabel, rows } from "../helpers";

var root = $.from_html(`<span class="slex-list-description"> </span>`);
var root_1 = $.from_html(`<li> <!></li>`);

export default function List($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var fragment = $.comment();
	var node = $.first_child(fragment);

	$.element(node, () => $.get(p).ordered === true ? "ol" : "ul", false, ($$element, $$anchor) => {
		$.attribute_effect($$element, () => ({
			class: 'slex-list',
			'data-ordered': $.get(p).ordered === true ? "true" : "false"
		}));

		var fragment_1 = $.comment();
		var node_1 = $.first_child(fragment_1);

		$.each(node_1, 17, () => rows($.get(p).items), $.index, ($$anchor, item) => {
			var li = root_1();
			var text = $.child(li, true);
			var node_2 = $.sibling(text);

			{
				var consequent = ($$anchor) => {
					var span = root();
					var text_1 = $.child(span, true);

					$.reset(span);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => itemDescription($.get(item))]);
					$.append($$anchor, span);
				};

				var d = $.derived(() => itemDescription($.get(item)));

				$.if(node_2, ($$render) => {
					if ($.get(d)) $$render(consequent);
				});
			}

			$.reset(li);
			$.template_effect(($0) => $.set_text(text, $0), [() => itemLabel($.get(item))]);
			$.append($$anchor, li);
		});

		$.append($$anchor, fragment_1);
	});

	$.append($$anchor, fragment);
	$.pop();
}